module.exports = __webpack_public_path__ + "static/media/icon-sum.23c39b17.svg";